module.exports = __webpack_public_path__ + "static/media/wETH.9744dd60.png";